import { sourceQuoteBlockers, sourceQuotes, sourceQuoteSummary } from "../knowledge/sourceQuotes.js";

export function QuoteLedger({ compact = false }) {
  const summary = sourceQuoteSummary();

  return (
    <section className={compact ? "quote-ledger compact" : "quote-ledger"}>
      <div className="section-heading">
        <h2>Source-Grounded Quotes</h2>
        <span className="micro-status">{summary.valid}/{summary.total} displayable</span>
      </div>
      <div className="quote-grid">
        {sourceQuotes.map((quote) => (
          <article className="quote-card" key={quote.id}>
            <blockquote>{quote.text}</blockquote>
            <p>{quote.work} · {quote.author}{quote.translator ? ` · ${quote.translator}` : ""}</p>
            <span>{quote.chapterOrSection}</span>
            <strong>{quote.custodyLane}</strong>
          </article>
        ))}
      </div>
      {!compact ? (
        <div className="blocked-source-list">
          {sourceQuoteBlockers.map((blocker) => (
            <div className="blocked-source-row" key={blocker.id}>
              <strong>{blocker.label}</strong>
              <span>{blocker.status} · {blocker.reason}</span>
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
